import React, { ReactNode, VFC } from 'react';
import Link from '@material-ui/core/Link';
import { HOME } from '../../../constants/routing';

interface Props {
  children: ReactNode;
}
const HomeLink: VFC<Props> = ({ children }: Props) => {
  const isShowLink = window.location.pathname !== HOME;
  return <>{isShowLink ? <Link href={HOME}>{children}</Link> : children}</>;
};

export default HomeLink;
